import { ReactNode } from 'react';
import { MultiLocationAccordionControlAccordion } from './multi-location-accordion-control-accordion';
import { MultiLocationAccordionControlHeader } from './multi-location-accordion-control-header';
import { MultiLocationAccordionControlModal } from './multi-location-accordion-control-modal';

type Props = {
  children: ReactNode;
};

/**
 * Weave Assistant Multi Control Component
 * This component allows users to manage the Weave Assistant settings across multiple locations.
 * It provides a modal to toggle the Weave Assistant on or off for each selected location.
 *
 * @param children - optional children to render inside the control
 *
 * @returns MultiLocationAccordionControl component
 */
export const MultiLocationAccordionControl = ({ children }: Props) => children;

MultiLocationAccordionControl.Header = MultiLocationAccordionControlHeader;
MultiLocationAccordionControl.Accordion = MultiLocationAccordionControlAccordion;
MultiLocationAccordionControl.Modal = MultiLocationAccordionControlModal;
